import toast from 'react-hot-toast';
import secure_axios from '../secure_axios';

import { downloadWithFileName, trataErroBlob } from '../../util/download';

const baseUrl = 'report'
const loadingMessage = 'Criando Relatório...'

async function servGeraFormAcompTrimestral(dataInicio, dataFim, downloadFile = true) {
    try {
        const response = await toast.promise(
            secure_axios.get(`${baseUrl}/formulario-acompanhamento/trimestral`,
                {
                    params: { dataInicio, dataFim, downloadFile },
                    responseType: downloadFile ? 'blob' : 'json'
                }
            ), { loading: loadingMessage }
        )
        if (downloadFile) {
            downloadWithFileName(response);
        }
    } catch (error) {
        console.error(error);
        trataErroBlob(error);
    }
}

async function servGeraRelAcompMensal(mesReferencia, somenteCapa = true, downloadFile = true) {
    try {
        const response = await toast.promise(
            secure_axios.get(`${baseUrl}/formulario-acompanhamento/mensal`,
                {
                    params: { mesReferencia, somenteCapa, downloadFile },
                    responseType: downloadFile ? 'blob' : 'json'
                }
            ), { loading: loadingMessage }
        )
        if (downloadFile) {
            downloadWithFileName(response);
        }
    } catch (error) {
        console.error(error);
        trataErroBlob(error);
    }
}

async function servGeraRelPendTrim(dataInicio, dataFim, downloadFile = true) {
    try {
        const response = await toast.promise(
            secure_axios.get(`${baseUrl}/pendencias-trimestrais/xlsx`,
                {
                    params: { dataInicio, dataFim, downloadFile },
                    responseType: downloadFile ? 'blob' : 'json'
                }
            ), { loading: loadingMessage }
        )
        if (downloadFile) {
            downloadWithFileName(response);
        }
    } catch (error) {
        console.error(error);
        trataErroBlob(error);
    }
}

async function servGeraRelPendTrimHist(dataInicio, dataFim, downloadFile = true) {
    try {
        const response = await toast.promise(
            secure_axios.get(`${baseUrl}/pendencias-trimestrais/historico`,
                {
                    params: { dataInicio, dataFim, downloadFile },
                    responseType: downloadFile ? 'blob' : 'json'
                }
            ), { loading: loadingMessage }
        )
        if (downloadFile) {
            downloadWithFileName(response);
        }
    } catch (error) {
        console.error(error);
        trataErroBlob(error);
    }
}

async function servGeraRelIndicPorPeriodoEMetrica(dataInicio, dataFim, metricaId, downloadFile = true) {
    try {
        const response = await toast.promise(
            secure_axios.get(`${baseUrl}/indicador/por-periodo-e-metrica`,
                {
                    params: { dataInicio, dataFim, metricaId, downloadFile },
                    responseType: downloadFile ? 'blob' : 'json'
                }
            ), { loading: loadingMessage }
        )
        if (downloadFile) {
            downloadWithFileName(response);
        }
    } catch (error) {
        console.error(error);
        trataErroBlob(error);
    }
}

function geraRelatorioNovo({ codigoRelatorio, tipoFiltro, mesReferencia, dataInicio, dataFim, metricaId, downloadFile }) {
    const funcoesGeradoras = {
        2: () => servGeraRelAcompMensal(mesReferencia, false, downloadFile),
        4: () => servGeraRelPendTrimHist(dataInicio, dataFim, downloadFile),
        5: () => servGeraFormAcompTrimestral(dataInicio, dataFim, downloadFile),
        6: () => servGeraRelPendTrim(dataInicio, dataFim, downloadFile),
        7: () => servGeraRelAcompMensal(mesReferencia, true, downloadFile),
        8: () => servGeraRelIndicPorPeriodoEMetrica(dataInicio, dataFim, metricaId, downloadFile)
    }

    if (tipoFiltro === 'MES') {
        if (!mesReferencia) {
            toast.error('Selecione o Mês de Referência para gerar o relatório.')
            return
        }
    } else if (tipoFiltro === 'PERIODO') {
        if (!dataInicio || !dataFim) {
            toast.error('Selecione o Período (Mês Inicial e Mês Final) para gerar o relatório.')
            return
        }
    } else {
        toast.error('Tipo de período inválido!')
        return
    }

    const funcaoGeradora = funcoesGeradoras[codigoRelatorio]

    if (!funcaoGeradora) {
        console.error(`Código de relatório inválido: ${codigoRelatorio}`)
        return
    }
    return funcaoGeradora()
}

export {
    geraRelatorioNovo
}
